import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLabelTag = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.5 9.16699L11.1716 2.83856C10.7392 2.40619 10.523 2.19 10.2707 2.03539C10.047 1.89832 9.80317 1.79731 9.54808 1.73607C9.26036 1.66699 8.95462 1.66699 8.34314 1.66699L5 1.66699M2.5 7.25033L2.5 8.89576C2.5 9.30341 2.5 9.50723 2.54605 9.69904C2.58688 9.8691 2.65422 10.0317 2.7456 10.1808C2.84867 10.349 2.9928 10.4931 3.28105 10.7814L9.78105 17.2814C10.4411 17.9414 10.7711 18.2714 11.1516 18.3951C11.4864 18.5038 11.847 18.5038 12.1817 18.3951C12.5622 18.2714 12.8923 17.9414 13.5523 17.2814L15.6144 15.2193C16.2744 14.5592 16.6044 14.2292 16.7281 13.8487C16.8368 13.5139 16.8368 13.1534 16.7281 12.8186C16.6044 12.4381 16.2744 12.1081 15.6144 11.448L9.53105 5.36471C9.2428 5.07645 9.09867 4.93233 8.93048 4.82926C8.78135 4.73788 8.61878 4.67054 8.44872 4.62971C8.25691 4.58366 8.05308 4.58366 7.64543 4.58366H5.16667C4.23325 4.58366 3.76654 4.58366 3.41002 4.76531C3.09641 4.9251 2.84145 5.18007 2.68166 5.49367C2.5 5.85019 2.5 6.3169 2.5 7.25033Z",
		stroke: "#4F31FF",
		strokeWidth: 1.66667,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgLabelTag;
